import { defineComponent as _defineComponent } from 'vue'
import { nextTick, onMounted, ref } from 'vue';
import { CdnImg } from '@webplatform/cdn-image';
import { handleImageSrc, handleImageAlt } from '~/helpers';
import { useSwiperElement } from '~/composables';

interface Props {
  images?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSeriesGallery',
  props: {
    images: { default: () => [] }
  },
  setup(__props: any) {



const isSwiperMainInit = ref(false);
const isSwiperThumbsInit = ref(false);

const swiperMainEl = useSwiperElement({
  on: {
    init: () => {
      isSwiperMainInit.value = true;
    },
  },
});

const swiperThumbsEl = useSwiperElement({
  slidesPerView: 'auto',
  spaceBetween: 16,
  loop: false,
  breakpoints: {
    1024: {
      direction: 'vertical',
      spaceBetween: 8,
    },
  },
  on: {
    init: () => {
      isSwiperThumbsInit.value = true;
    },
  },
});

onMounted(() => {
  nextTick(() => {
    const main = swiperMainEl.value?.swiper;
    const thumbs = swiperThumbsEl.value?.swiper;
    // destroy() снимает модули с инстанса, если элемент уже успели убрать из DOM
    if (!main || main.destroyed || !thumbs || thumbs.destroyed) return;

    main.controller.control = thumbs;
    thumbs.controller.control = main;
  });
});

const slideTo = (i: number) => {
  swiperMainEl.value?.swiper?.slideTo(i);
};

return { __sfc: true,isSwiperMainInit, isSwiperThumbsInit, swiperMainEl, swiperThumbsEl, slideTo, CdnImg, handleImageSrc, handleImageAlt }
}

})